module.exports = __webpack_public_path__ + "img/vippack-badge.a8a5e6e5.svg";